export default __webpack_public_path__ + "static/media/image2.3f4626e5.svg";